import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';

import { Helpers } from '../services/helpers';

export const getUtmObject = () => {
  if (process.client) {
    try {
      return JSON.parse(window?.sessionStorage.getItem('utmObject')) || {};
    } catch (err) {
      getLoggerService().logger.error('Error occurred during getting items from sessionStorage', err);
      return {};
    }
  }
};

export const setUtmObject = (utmObject) => {
  try {
    const cleanUtmObject = Helpers.cleanEmptyKeysFromObj(utmObject);
    window?.sessionStorage.setItem('utmObject', JSON.stringify(cleanUtmObject));
  } catch (err) {
    getLoggerService().logger.error('Error occurred during setting items from sessionStorage', err);
    console.error('Cannot set UTM object');
  }
};
